import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;

  @media ${({ theme }) => theme.queries.minTablet} {
    flex-direction: row;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;

  @media ${({ theme }) => theme.queries.minTablet} {
    height: auto;
  }
`;
